import { render, staticRenderFns } from "./CalendarOwnerSelector.vue?vue&type=template&id=351568fe"
import script from "./CalendarOwnerSelector.vue?vue&type=script&lang=js"
export * from "./CalendarOwnerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports